import { combineEpics } from 'redux-observable';
import { authEpic$ } from '../logic/store/auth/auth.epics';
import { boardEpic$ } from '../logic/store/board/board.epics';

export const rootEpic = combineEpics(authEpic$, boardEpic$);
